import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import Layout from "../components/Layout";
import api, { mediaUrl } from "../lib/api";
import { EText } from "../components/cms/Editable";

export default function Trainings() {
  const [trainings, setTrainings] = useState([]);
  useEffect(() => { api.get("/trainings").then((r) => setTrainings(r.data)); }, []);

  return (
    <Layout>
      <section className="section-pad">
        <div className="text-center mb-12">
          <EText k="trainings.pill" className="pill bg-brand-cream2 text-brand-tan">Diamond Dharma Trainings</EText>
          <EText k="trainings.title" as="h1" className="font-display text-4xl sm:text-5xl font-semibold text-brand-ink mt-3 block">Signature Training Programs</EText>
          <EText k="trainings.subtitle" as="p" multiline className="mt-3 text-brand-inksoft max-w-2xl mx-auto block">Three complete programs from Seymour Koblin — included with Diamond Dharma membership.</EText>
        </div>
        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {trainings.map((tr) => (
            <div key={tr.id} className="card-surface overflow-hidden flex flex-col" data-testid={`training-card-${tr.id}`}>
              <div className="relative aspect-video">
                <img src={mediaUrl(tr.thumbnail)} alt={tr.title} className={`w-full h-full object-cover ${!tr.unlocked ? "blur-sm" : ""}`} />
                {!tr.unlocked && <div className="absolute inset-0 bg-black/45 flex items-center justify-center"><Lock className="text-brand-gold" size={28} /></div>}
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <h3 className="font-display text-2xl font-semibold text-brand-ink">{tr.title}</h3>
                <p className="text-sm text-brand-inksoft mt-2 flex-1">{tr.teaser}</p>
                {tr.unlocked ? (
                  <Link to={`/trainings/${tr.id}`} className="btn-primary mt-4" data-testid={`open-training-${tr.id}`}>Open Training <ArrowRight size={16} /></Link>
                ) : (
                  <Link to="/packages?tier=diamond&checkout=true" className="btn-gold mt-4" data-testid={`unlock-training-${tr.id}`}>Unlock with Diamond — $50</Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
